import { ExportOutlined } from "@ant-design/icons";
import { Button, ButtonProps, Tooltip } from "antd";
import React from "react";

export const BIN_DETAILS_TOOLTIP_TEXT = "Go to Bin Details";
export const BinDetailsButton = (props: ButtonProps) => {
    return <Tooltip title={BIN_DETAILS_TOOLTIP_TEXT}>
        <Button
            ghost={false}
            type="primary"
            icon={<ExportOutlined />}
            {...props}>
                {props.children}
        </Button>
    </Tooltip>
}